// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.9997 0.585938L23.4139 7.00015L21.9997 8.41437L20.0558 6.47045C19.4109 7.26977 18.5565 8.44755 17.7951 9.81267C16.7659 11.658 15.9772 13.7209 15.9872 15.6006C17.4586 17.3736 17.3652 20.049 15.7068 21.7073C13.9495 23.4646 11.05 23.4646 9.29263 21.7073C7.53527 19.9499 7.53527 17.0504 9.29263 15.293C10.5761 14.0096 12.4688 13.6635 14.0808 14.2547C14.3505 12.3162 15.1661 10.4204 16.0484 8.83845C16.6052 7.84012 17.2072 6.93421 17.7588 6.17956C17.1352 6.25648 16.4194 6.36594 15.6584 6.52149C13.4862 6.96552 11.0856 7.75793 9.36203 9.12517C10.427 10.8696 10.2086 13.2055 8.70684 14.7073C6.94948 16.4646 4.04999 16.4646 2.29263 14.7073C0.535269 12.9499 0.53527 10.0504 2.29263 8.29305C3.81825 6.76743 6.20462 6.56625 7.95726 7.6895C10.0807 5.9338 12.9453 5.03472 15.2579 4.56201C16.1759 4.37437 17.03 4.24944 17.7516 4.16625L15.5855 2.00015L16.9997 0.585938Z"}}]};

const CherryFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cherry-filled',
    ref,
    icon: element,
  },
));

CherryFilledIcon.displayName = 'CherryFilledIcon';

export default CherryFilledIcon;
